module.exports = __webpack_public_path__ + "img/tarjeta-de-credito.7786f140.png";